<template>
  <div>
    <b-card>
      <title-card />
      <content-text />
    </b-card>
    <!--    <image-card />-->
  </div>
</template>

<script>
import {
  BCard,
} from 'bootstrap-vue'
import TitleCard from '@/views/Admin/Laboratory_policy/Elements/TitleCard.vue'
import ContentText from '@/views/Admin/Laboratory_policy/Elements/Content.vue'
// import ImageCard from '@/views/Admin/Laboratory_policy/Elements/Image.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    TitleCard,
    ContentText,
    // ImageCard,
  },
}
</script>
